import { startCase } from 'lodash';
import { RECURRING_TIME_UNITS } from '../../types/recurringTimeUnits';
import { TIME_UNITS } from '../../types/timeUnits';

export const createMpShowPageEventParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName,
    'Is Pro': data.isPro,
    'Source Component': data.sourceComponent,
    'Gig Card Position': data.pos,
    'Context Page Number': data.contextPageNumber,
    'Number of Packages': data.packagesCount,
    'Is Promoted Gig': data.isPromotedGig,
    'Buyer Assumed Language': data.buyerAssumedLanguage,
    'Has work process': data.hasWorkProcess,
    'Min package price': data.minPackagePrice,
    'Seller Languages': data.sellerValidatedLanguages,
    'Seller Country': data.sellerCountryCode
});

export const createMpComparePackagesParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName
});

export const createMpPackageSelectParams = (data) => ({
    'Package Position': startCase(data.source),
    'Package Selected': data.id,
    'Is subscription': !!data.selectedRecurringOption,
    ...getRecurringParams(data)
});

const getRecurringParams = ({ selectedRecurringOption }) =>
    selectedRecurringOption
        ? buildRecurringOptionParams(selectedRecurringOption)
        : {};

const buildRecurringOptionParams = ({ duration, durationTimeUnit, discountPercentage }) => ({
    'Subscription Length': duration,
    'Subscription Time Unit': startCase(transformTimeUnit(durationTimeUnit)),
    'Discount Percentage': discountPercentage
});

const transformTimeUnit = (durationTimeUnit) => {
    switch (durationTimeUnit){
        case RECURRING_TIME_UNITS.WEEK:
            return TIME_UNITS.WEEK;
        case RECURRING_TIME_UNITS.MONTH:
            return TIME_UNITS.MONTH;
        default:
            return TIME_UNITS.MONTH;
    }
};

export const createMpTopNavClickParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName,
    'Displayed Sections': data.displayedSections,
    'Clicked Section': data.clickedSection
});

export const createMpSellerAnchorClickParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName
});

export const createChangedRecurringOption = (data) => ({
    'Package Position': startCase(data.source),
    'Subscription Length': data.duration
});

export const createChangedCheckoutPlan = (data) => ({
    'Package Position': startCase(data.source),
    'Checkout Plan': startCase(data.selectedCheckoutPlan)
});

export const createMpClickedTab = (data) => ({
    'Tab Name': data['Tab Name'],
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName,
    'Category Id': data.categoryId,
    'Sub Category Id': data.subCategoryId,
    'Nested Sub Category Id': data.nestedSubCategoryId,
    'Is pro': data.isPro
});

export const createMpBreadcrumbsClickParams = (data) => ({
    'Category Id': data.categoryId,
    'Sub Category Id': data.subCategoryId,
    'Nested Sub Category Id': data.nestedSubCategoryId,
    'Is pro': data.isPro
});
